import PublicPageRenderer from '@/components/builder/PublicPageRenderer';
import { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { leadsAPI } from '@/lib/api';
import { SEO } from '@/components/SEO';

export default function About() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' });
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await leadsAPI.create({ ...form, type: 'inquiry' });
      toast.success('Message sent! We\'ll get back to you shortly.');
      setForm({ name: '', email: '', phone: '', message: '' });
    } catch { toast.error('Failed to send. Please try again.'); }
    setSubmitting(false);
  };

  return (
    <div data-testid="about-page">
      <SEO
        title="About Us | Trusted Truck & Trailer Dealer Since 2005"
        description="Canadian Truck Sales is Mississauga's most trusted used truck and trailer dealer. 20+ years experience, 500+ units sold, 98% client satisfaction. Located at 5939 Shawson Dr, serving the GTA, Ontario, and across Canada. Visit us or call (416) 417-2525."
        url="/about"
        keywords="about Canadian Truck Sales, CTS Mississauga, truck dealer about us, trusted truck dealer Ontario, best truck dealer Mississauga, Shawson Drive truck dealer, used truck dealer reviews, Canadian Truck Sales reviews, CTS trucks reviews"
      />
      <PublicPageRenderer slug="about" />

      {/* Contact Form Section - always shown */}
      <section className="py-16 md:py-24 bg-zinc-50">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-semibold uppercase mb-6 text-center">Contact Us</h2>
          <div className="bg-white p-8 rounded-sm shadow-sm">
            <form onSubmit={handleSubmit} className="space-y-4">
              <Input placeholder="Full Name *" required value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} data-testid="contact-name" />
              <Input placeholder="Email *" type="email" required value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} data-testid="contact-email" />
              <Input placeholder="Phone" value={form.phone} onChange={e => setForm(f => ({ ...f, phone: e.target.value }))} data-testid="contact-phone" />
              <Textarea placeholder="How can we help you?" required value={form.message} onChange={e => setForm(f => ({ ...f, message: e.target.value }))} rows={4} data-testid="contact-message" />
              <Button type="submit" className="w-full bg-[#E31937] hover:bg-[#C4122C] text-white font-bold uppercase" disabled={submitting} data-testid="contact-submit">
                {submitting ? 'Sending...' : 'Send Message'}
              </Button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}
